import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const IconItemSchema = buildEntrySchemaFor('iconItem', {
  fields: z.lazy(() =>
    z.object({
      heading: RichTextSchema.optional(),
      description: RichTextSchema.optional(),
      icon: z.string().optional(),
    }),
  ),
})
export type IconItem = z.infer<typeof IconItemSchema>
